var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRelacionamentoVirtual(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 65 58",
    style: {
      enableBackground: "new 0 0 65 58"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9B0008;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.1,0H4.9C2.2,0,0,2.2,0,4.9v40c0,2.7,2.2,4.9,4.9,4.9h18.7V56h-6.7c-0.6,0-1,0.4-1,1s0.4,1,1,1h31.2 c0.6,0,1-0.4,1-1s-0.4-1-1-1h-6.7v-6.2h18.7c2.7,0,4.9-2.2,4.9-4.9v-6.1c0-0.6-0.4-1-1-1s-1,0.4-1,1V42H34.3V28.6 c0-3.7-3-6.8-6.8-6.8H12.8c-3.7,0-6.7,3-6.8,6.8V42H2V5c0-1.6,1.3-3,2.9-3h55.2c1.6,0,3,1.4,3,3v0.2c0,0.6,0.4,1,1,1s1-0.4,1-1 V4.9C65,2.2,62.8,0,60.1,0C60.1,0,60.1,0,60.1,0z M39.4,56H25.6v-6.2h13.8V56z M7.9,28.6c0-2.7,2.2-4.8,4.8-4.8c0,0,0,0,0,0h6.5 v13.3c0,0.6,0.4,1,1,1s1-0.4,1-1V23.8h6.3c2.7,0,4.8,2.2,4.8,4.8V42h-3.9V29.6c0-0.6-0.4-1-1-1s-1,0.4-1,1V42H13.7V29.6 c0-0.6-0.4-1-1-1s-1,0.4-1,1V42H7.9V28.6z M6.9,43.9H63v1c0,1.6-1.3,3-3,3H4.9c-1.7,0-3-1.3-3-3v-1H6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14,13.2c0,3.4,2.7,6.1,6.1,6.1c3.4,0,6.1-2.7,6.1-6.1c0-3.4-2.7-6.1-6.1-6.1c0,0-0.1,0-0.1,0 C16.7,7.2,14,9.8,14,13.2z M24.2,13.2c0,2.3-1.8,4.1-4.1,4.1S16,15.5,16,13.2c0-2.3,1.8-4.1,4-4.1C22.3,9,24.1,10.9,24.2,13.2 C24.1,13.1,24.1,13.1,24.2,13.2L24.2,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.9,9.1H41.5c-1.7,0-3.1,1.4-3.1,3.1c0,0,0,0,0,0v1.6h-5.1c-0.4,0-0.7,0.2-0.9,0.5c-0.2,0.3-0.2,0.7,0,1 l5.7,8.6c0.1,0.2,0.2,0.4,0.2,0.6v7.2c0,1.7,1.4,3.1,3.1,3.1h20.4c1.7,0,3.1-1.4,3.1-3.1c0,0,0,0,0,0V12.2 C65,10.4,63.6,9.1,61.9,9.1z M63,31.8c0,0.6-0.5,1.1-1.1,1.1c0,0,0,0,0,0H41.5c-0.6,0-1.1-0.5-1.1-1.1c0,0,0,0,0,0v-7.2 c0-0.6-0.2-1.2-0.5-1.7l-4.7-7.1h4.2c0.6,0,1-0.4,1-1v-2.6c0-0.6,0.5-1.1,1.1-1.2h20.4c0.6,0,1.1,0.5,1.1,1.2V31.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.1,15.1H45.3c-0.6,0-1,0.4-1,1s0.4,1,1,1h12.8c0.6,0,1-0.4,1-1S58.7,15.1,58.1,15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.1,21H45.3c-0.6,0-1,0.4-1,1s0.4,1,1,1h12.8c0.6,0,1-0.4,1-1S58.7,21,58.1,21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.2,26.9h-7.9c-0.6,0-1,0.4-1,1s0.4,1,1,1h7.9c0.6,0,1-0.4,1-1S53.7,26.9,53.2,26.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelacionamentoVirtual);
export default __webpack_public_path__ + "static/media/relacionamento_virtual.039f137c4ad1cc16d5da0cac6ad65456.svg";
export { ForwardRef as ReactComponent };